<template>
    <router-view></router-view>
    <section class="loader-wrapper " v-if="loaderItem">
        <div class="loader">
            <h2 class="thm-heading-two ">Dreasy </h2>
            <div class="loader-center">
                <div class="plane">
                    <img src="../public/Agent/images/plane-img.png" class="plane-img">
                </div>
                <div class="earth-wrapper">
                    <div class="earth"></div>
                </div>
            </div>
            <h2 class="thm-heading-two ">Fly</h2>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            loaderItem: false,
        }
    },
    methods: {
        toggleLoader(status) {
            this.loaderItem = status;
        },
    },
}
</script>
